import { cn } from '@/lib/utils';

interface AuthPointsSelectorProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
}

const AuthPointsSelector = ({ value, onChange, max = 5 }: AuthPointsSelectorProps) => {
  return (
    <div className="flex gap-2">
      {Array.from({ length: max }, (_, i) => i + 1).map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          className={cn(
            'flex h-9 flex-1 items-center justify-center rounded-lg border text-sm font-medium transition-colors',
            n === value
              ? 'border-selected text-foreground'
              : 'border-border bg-background text-foreground hover:bg-muted/50'
          )}
        >
          {n}
        </button>
      ))}
    </div>
  );
};

export default AuthPointsSelector;
